import React from 'react';
import { observer } from '../../shared/observer';
import { authService } from '../../stores/authStore/service';
import { makeConsentsHelpers } from './Consents';

class EmailLoginView extends React.Component {
  state = { mode: 'login', email: '', password: '', name: '', error: null, msg: null, sending: false, agrees: {}, recoveryCooldown: 0 };

  componentWillUnmount() {
    this._unmounted = true;
    this.stopCooldown();
  }

  set = (k) => (e) => this.setState({ [k]: e.target.value, error: null });

  switchMode = (mode) => (e) => { e.preventDefault(); this.setState({ mode, error: null, msg: null }); };

  componentWillReceiveProps(next) {
    if (next.auth && next.auth.isAuthenticated) this.props.onAuthed && this.props.onAuthed();
  }

  // Обратный отсчёт до возможности повторного письма восстановления (анти-спам).
  startCooldown = () => {
    this.stopCooldown();
    this.setState({ recoveryCooldown: 30 });
    this._cooldownTimer = setInterval(() => {
      if (this.state.recoveryCooldown <= 1) {
        this.stopCooldown();
        this.setState({ recoveryCooldown: 0 });
      } else {
        this.setState({ recoveryCooldown: this.state.recoveryCooldown - 1 });
      }
    }, 1000);
  };

  stopCooldown = () => {
    if (this._cooldownTimer) { clearInterval(this._cooldownTimer); this._cooldownTimer = null; }
  };

  submit = async (e) => {
    e.preventDefault();
    if (this.state.sending) return;
    const { mode, email, password, name } = this.state;
    this.setState({ sending: true, error: null, msg: null });
    try {
      if (mode === 'login') {
        await this.props.auth.loginByEmail(email, password);
      } else if (mode === 'register') {
        const res = await authService.registerByEmail({ email, password, name });
        this.props.auth.setMobileToken(res.mobile_token);
      } else if (mode === 'recovery') {
        await authService.emailRecovery(email);
        if (this._unmounted) return;
        this.setState({ msg: 'Если email зарегистрирован, мы прислали инструкции', sending: false });
        this.startCooldown();
        return;
      }
    } catch (err) {
      if (this._unmounted) return;
      this.setState({ error: err.message || 'Не удалось', sending: false });
      return;
    }
    // при успешном логине диалог уже мог закрыться (onAuthed) — компонент размонтирован
    if (this._unmounted) return;
    this.setState({ sending: false });
  };

  render() {
    const { mode, email, password, name, error, msg, sending, recoveryCooldown } = this.state;
    const consents = makeConsentsHelpers(this);
    // На recovery согласия не требуем — это просто запрос ссылки на e-mail.
    const needConsents = mode !== 'recovery';
    const cooldown = mode === 'recovery' ? recoveryCooldown : 0;
    const canSubmit = !sending && cooldown === 0 && (!needConsents || consents.ok());
    return (
      <form className="login-box" onSubmit={(e) => { if (!canSubmit) { e.preventDefault(); return; } this.submit(e); }}>
        <div className="h1">
          {mode === 'login' ? 'Личный кабинет' : mode === 'register' ? 'Регистрация' : 'Восстановление пароля'}
        </div>
        {mode === 'register' && (
          <input className="input__text" type="text" placeholder="Имя" value={name} onChange={this.set('name')} />
        )}
        <input className="input__text" type="email" placeholder="Email" value={email} onChange={this.set('email')} required />
        {mode !== 'recovery' && (
          <input className="input__text" type="password" placeholder="Пароль" value={password} onChange={this.set('password')} required />
        )}
        {error && <div className="order-message">{error}</div>}
        {msg && <div className="order-message">{msg}</div>}
        {needConsents && consents.render()}
        <button type="submit" className={'btn ' + (canSubmit ? '' : 'btn--disabled') + (sending ? ' is-busy' : '')} disabled={!canSubmit}>
          {mode === 'login' ? 'Войти'
            : mode === 'register' ? 'Зарегистрироваться'
            : cooldown > 0 ? `Отправить снова через ${cooldown} с` : 'Отправить'}
        </button>
        <div style={{ fontSize: 13, marginTop: 8 }}>
          {mode !== 'login' && (
            <a href="#" onClick={this.switchMode('login')}>Войти</a>
          )}
          {mode === 'login' && (
            <span>
              <a href="#" onClick={this.switchMode('register')}>Регистрация</a>
              {' · '}
              <a href="#" onClick={this.switchMode('recovery')}>Забыли пароль?</a>
            </span>
          )}
        </div>
      </form>
    );
  }
}

export const EmailLogin = observer(EmailLoginView, ['authStore']);



// WEBPACK FOOTER //
// ./app/javascript/website_newgen/js/components/Auth/EmailLogin.jsx